<template>
  <div class="sampleWebsocket">
    <div class="buttons">
        <div class="minus button" @click="clickMinus()">-</div>
        <div class="value">{{value}}</div>
        <div class="plus button" @click="clickPlus()">+</div>
    </div>
    <div class="state">
        <span class="users">{{ users }}</span> online
    </div>
    <div>
        <el-button @click="clickProduct()">Product</el-button>
        <el-button @click="clickCustomer()">Customer</el-button>
    </div>
  </div>
</template>

<script src="//code.jquery.com/jquery-1.12.4.min.js" integrity="sha256-ZosEbRLbNQzLpnKIkEdrPv7lOy9C27hHQ+Xp8a4MxAQ=" crossorigin="anonymous"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/socket.io/2.2.0/socket.io.js" integrity="sha256-yr4fRk/GU1ehYJPAs8P4JlTgu0Hdsp4ZKrx8bDEDC3I=" crossorigin="anonymous"></script>
<script>

export default {  
    name: 'sampleWebsocket',
    data() {
        return {
            value: '?',
            users: '?'
            // websocket: {}
        }
    },
    mounted() {
        // this.websocket = new WebSocket("ws://127.0.0.1:6789");
        // this.websocket.onmessage = this.onmessage;
        this.socket.on('result', (data) => {
            console.error(data);
        });
    },
    methods: {
        clickMinus() {
            // this.websocket.send(JSON.stringify({action: 'minus'}));
            this.sendSocket('minus');
        },
        clickPlus() {
            this.sendSocket('plus');
            // this.websocket.send(JSON.stringify({action: 'plus'}));
        },
        clickProduct() {
            this.api.listProduct();
        },
        clickCustomer() {
            this.api.listCustomer();
        },
        onmessage(event) {
            // const data = JSON.parse(event.data);
            console.error(event.data);
            // switch (data.type) {
            //     case 'state':
            //         this.value = data.value;
            //         break;
            //     case 'users':
            //         this.users = (
            //             data.count.toString() + " user" +
            //             (data.count == 1 ? "" : "s"));
            //         break;
            //     default:
            //         console.error("unsupported event", data);
            // }
        }
    }  
}
</script>

<style lang="scss" scoped>
.sampleWebsocket { text-align: center; }
.buttons {
    font-size: 4em;
    display: flex;
    justify-content: center;
}
.button, .value {
    line-height: 1;
    padding: 2rem;
    margin: 2rem;
    border: medium solid;
    min-height: 1em;
    min-width: 1em;
}
.button {
    cursor: pointer;
    user-select: none;
}
.minus {
    color: red;
}
.plus {
    color: green;
}
.value {
    min-width: 2em;
}
.state {
    font-size: 2em;
}
</style>